import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import Form from "@saleor/components/Form";
import Grid from "@saleor/components/Grid";
import PageHeader from "@saleor/components/PageHeader";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import { ShopErrorFragment } from "@saleor/fragments/types/ShopErrorFragment";
import { SubmitPromise } from "@saleor/hooks/useForm";
import useStateFromProps from "@saleor/hooks/useStateFromProps";
import { sectionNames } from "@saleor/intl";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { SiteLanguageDetails_siteLanguage } from "../../types/SiteLanguageDetails";
import CheckoutPopupImage from "../CheckoutPopupImage";
import SiteLanguageInfo from "../SiteLanguageInfo";
import SiteLanguageSummary from "../SiteLanguageSummary";

export interface SiteLanguageDetailPageFormData {
  name: string;
  domain: string;
  language: string;
  isActive: boolean;
  checkoutPopupImage: string;
}

export interface SiteLanguageDetailsPageProps {
  disabled: boolean;
  errors: ShopErrorFragment[];
  siteLanguage: SiteLanguageDetails_siteLanguage;
  saveButtonBarState: ConfirmButtonTransitionState;
  onBack: () => void;
  onRemove: () => void;
  onSubmit: (data: SiteLanguageDetailPageFormData) => SubmitPromise;
}

const SiteLanguageDetailsPage: React.FC<SiteLanguageDetailsPageProps> = ({
  disabled,
  errors,
  siteLanguage,
  saveButtonBarState,
  onBack,
  onRemove,
  onSubmit
}) => {
  const intl = useIntl();

  const siteLanguageExists = siteLanguage !== null;
  const [image, setImage] = useStateFromProps(
    siteLanguage?.checkoutPopupImage || ""
  );
  const initialForm: SiteLanguageDetailPageFormData = {
    name: siteLanguage?.name || "",
    domain: siteLanguage?.domain || "",
    language: siteLanguage?.language || "",
    isActive: siteLanguage?.isActive,
    checkoutPopupImage: image
  };

  const handleSubmit = (data: SiteLanguageDetailPageFormData) => {
    onSubmit({
      ...data
    });
  };

  return (
    <Form initial={initialForm} onSubmit={handleSubmit}>
      {({ change, data, submit }) => (
        <Container>
          <AppHeader onBack={onBack}>
            {intl.formatMessage(sectionNames.siteLanguages)}
          </AppHeader>
          <PageHeader
            title={
              !siteLanguageExists
                ? intl.formatMessage({
                    defaultMessage: "Create Site Language",
                    description: "page header"
                  })
                : maybe(() => siteLanguage.name)
            }
          />
          <Grid>
            <div>
              <SiteLanguageInfo
                data={data}
                disabled={disabled}
                errors={errors}
                siteLanguage={siteLanguage}
                onChange={change}
              />
              <CardSpacer />
              <CheckoutPopupImage
                image={image}
                setImage={setImage}
                disabled={disabled}
                onChange={change}
                data={data}
              />
            </div>
            <div>
              <SiteLanguageSummary data={data} />
            </div>
          </Grid>
          <SaveButtonBar
            // disabled={disabled || !hasChanged}
            disabled={disabled}
            state={saveButtonBarState}
            onCancel={onBack}
            onDelete={siteLanguage === null ? undefined : onRemove}
            onSave={submit}
          />
        </Container>
      )}
    </Form>
  );
};
SiteLanguageDetailsPage.displayName = "SiteLanguageDetailsPage";
export default SiteLanguageDetailsPage;
